/** Named keys used by early scenes; values match assets.json keys. */
export const AssetKeys = {
  heroBase: 'hero_base',
  bgMeadowSky: 'bg_meadow_sky',
} as const;

/** Must not collapse to plain string — only known AssetKeys values. */
export type AssetKey = (typeof AssetKeys)[keyof typeof AssetKeys];
